<template>
  <div class="Properties">
    <div class="content">
      <div class="header">
        <div class="left">
          <h1>东京市房产和房屋出售</h1>
          <h2>89个结果</h2>
        </div>
        <div class="search">
          <el-input v-model="input" placeholder="请输入关键词"></el-input>
          <div class="selects">
            <!-- 东京下拉框 -->
            <div class="select-wrapper">
              <select v-model="tokyoValue" class="filter-select">
                <option value="">东京</option>
                <option value="central">东京中心区</option>
                <option value="shinjuku">新宿区</option>
                <option value="shibuya">涩谷区</option>
                <option value="chiyoda">千代田区</option>
              </select>
            </div>

            <!-- 地区/位置下拉框 -->
            <div class="select-wrapper">
              <select v-model="areaValue" class="filter-select">
                <option value="">地区/位置</option>
                <option value="near_station">车站附近</option>
                <option value="downtown">市中心</option>
                <option value="suburb">郊区</option>
                <option value="waterfront">水岸</option>
              </select>
            </div>

            <!-- 房源类型下拉框 -->
            <div class="select-wrapper">
              <select v-model="typeValue" class="filter-select">
                <option value="">房源类型</option>
                <option value="apartment">公寓</option>
                <option value="house">独栋住宅</option>
                <option value="office">办公室</option>
                <option value="land">土地</option>
              </select>
            </div>

            <!-- 房屋价格下拉框 -->
            <div class="select-wrapper">
              <select v-model="priceValue" class="filter-select">
                <option value="">房屋价格</option>
                <option value="under50">5000万日元以下</option>
                <option value="50-100">5000万-1亿日元</option>
                <option value="100-200">1亿-2亿日元</option>
                <option value="over200">2亿日元以上</option>
              </select>
            </div>
          </div>
          <img src="../assets/searchIcon.png" alt="" />
        </div>
      </div>
      <div class="main">
        <div
          class="box"
          v-for="(item, index) in propertyList"
          :key="index"
          @click="getPropertieDetail()"
        >
          <div class="img"><img :src="item.image" alt="" /></div>
          <div class="label">标签内容自己输入</div>
          <div class="bottom">
            <h1>兰乔帕迪斯｜独栋</h1>
            <h2>3室3卫｜室内：2,106呎｜占地：13,696呎</h2>
            <span>约¥1354.5万</span>
          </div>
        </div>
      </div>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      input: "",
      tokyoValue: "",
      areaValue: "",
      typeValue: "",
      priceValue: "",
      propertyList: [
        {
          image: require("../assets/list0.png"),
        },
        {
          image: require("../assets/list1.png"),
        },
        {
          image: require("../assets/list2.png"),
        },
        {
          image: require("../assets/list3.png"),
        },
        {
          image: require("../assets/list4.png"),
        },
        {
          image: require("../assets/list5.png"),
        },
      ],
    };
  },
  methods: {
    getPropertieDetail() {
      this.$router.push("/PropertieDetail");
    },
  },
};
</script>

<style scoped lang="less">
.content {
  margin: 0 auto;
  width: 100%;
  max-width: 75rem;
}
@media (max-width: 576px) {
  .Properties {
    padding: 25px 15px !important;
    .content {
      .header {
        flex-direction: column;
        align-items: flex-start;
        .left {
          h1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #1c1d25;
            text-align: left;
            line-height: normal;
          }
          h2 {
            font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
            font-weight: 400;
            font-size: 13px;
            color: #1c1d25;
            text-align: left;
            margin-bottom: 10px;
          }
        }
        .search {
          position: relative;
          width: 345px;
          height: 50px;
          .el-input {
            width: 100%;
          }
          .selects {
            position: absolute;
            left: 0;
            bottom: -30px;
            width: 100%;
            .filter-select {
              background: transparent;
            }
          }
        }
      }
      .main {
        padding-top: 15px;
        box-sizing: border-box;
        grid-template-columns: 1fr;
        .box {
          .label {
            font-size: 12px;
          }
          .bottom {
            padding: 14px 18px 22px;
            h1 {
              font-size: 14px;
              line-height: 18px;
            }
            h2 {
              font-size: 12px;
              line-height: 17px;
              margin: 7px 0;
            }
            span {
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
      .block {
        margin-top: 25px;
        .el-pagination {
          ::v-deep .el-pagination__sizes {
            display: none !important;
          }
          ::v-deep .el-pagination__jump {
            margin-left: 0;
          }
          ::v-deep .el-pager li {
            min-width: 25px !important;
          }
        }
      }
    }
  }
}
.Properties {
  background: #f7f7f7;
  padding: 55px 0 70px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    .left {
      h1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 35px;
        color: #1c1d25;
        line-height: 49px;
        text-align: left;
        margin-bottom: 10px;
      }
      h2 {
        font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
        font-weight: 400;
        font-size: 18px;
        color: #1c1d25;
        line-height: 26px;
        text-align: left;
      }
    }
    .search {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 636px;
      height: 62px;
      border-radius: 11px;
      border: 1px solid #efeded;
      background-color: #fff;
      padding-left: 20px;
      padding-right: 27px;
      img {
        width: 21px;
        height: 22px;
        cursor: pointer;
        margin-left: 10px;
      }
      ::v-deep .el-input {
        width: 40%;
        height: 100%;
      }
      ::v-deep .el-input__inner {
        width: 100%;
        height: 100%;
        // border-radius: 11px;
        border: none;
        padding: 0;
      }
      ::v-deep .el-input__inner::placeholder {
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 400;
        font-size: 14px;
        color: #535363;
      }
      ::v-deep .el-input__suffix {
        top: 3px;
      }
      .selects {
        display: flex;
        width: 60%;
        gap: 10px; /* 添加间距 */
        .select-wrapper {
          width: 25%;
        }
        .filter-select {
          position: relative;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          // background-color: pink;
          cursor: pointer;
          border: none;
          outline: none;
          box-shadow: none;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #1c1d25;
          line-height: 17px;
          text-align: left;
          // appearance: none; /* 移除默认样式 */
          &:focus {
            border: none !important;
            box-shadow: none !important;
          }
        }
      }
    }
  }
  .main {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(3, 1fr);
    .box {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 387px;
      background-color: #fff;
      border-radius: 16px;
      cursor: pointer;
      .label {
        position: absolute;
        top: 15px;
        right: 15px;
        background: rgba(16, 173, 235, 0.8);
        border-radius: 82px;
        padding: 4px 10px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #ffffff;
      }
      .img {
        width: 100%;
        img {
          width: 100%;
        }
      }
      .bottom {
        display: flex;
        flex-direction: column;
        padding: 15px 20px 25px;
        h1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #0d1222;
          line-height: 20px;
          text-align: left;
        }
        h2 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #1c1d25;
          line-height: 20px;
          text-align: left;
          margin: 10px 0;
        }
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: rgba(77, 77, 77, 0.5);
          line-height: 22px;
          text-align: left;
        }
      }
    }
  }
  .block {
    margin-top: 30px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    ::v-deep {
      .btn-prev,
      .btn-next,
      .el-pager li {
        background-color: transparent;
      }
    }
  }
}
</style>
